import api from './client';
import { API_ENDPOINTS } from './endpoints';

export type WorkflowFieldKey =
  | 'reporting_lead'
  | 'atl'
  | 'qc'
  | 'reporting_manager'
  | 'dispute_person'
  | 'reporting_sme'
  | 'senior_manager'
  | 'ceo';

export interface WorkflowFieldConfig {
  field_key: WorkflowFieldKey;
  enabled: boolean;
  source_role_names: string[];
}

export interface UpsertWorkflowConfigPayload {
  id?: string;
  role_name: string;
  show_daily_target: boolean;
  fields: WorkflowFieldConfig[];
}

export interface WorkflowConfigApiItem {
  _id: string;
  role_name: string;
  show_daily_target: boolean;
  fields: WorkflowFieldConfig[];
  meta?: {
    status?: string;
    createdAt?: string;
    updatedAt?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface WorkflowConfigsListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    workflowConfigs?: WorkflowConfigApiItem[];
  };
}

export interface WorkflowConfigMutationResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: WorkflowConfigApiItem;
}

export const getWorkflowConfigs = async (): Promise<WorkflowConfigsListResponse> => {
  return api.get<WorkflowConfigsListResponse>(API_ENDPOINTS.workflowConfig.list);
};

export const upsertWorkflowConfig = async (
  payload: UpsertWorkflowConfigPayload
): Promise<WorkflowConfigMutationResponse> => {
  return api.post<WorkflowConfigMutationResponse, UpsertWorkflowConfigPayload>(
    API_ENDPOINTS.workflowConfig.create,
    payload
  );
};

export const deleteWorkflowConfig = async (id: string): Promise<WorkflowConfigMutationResponse> => {
  return api.delete<WorkflowConfigMutationResponse>(`${API_ENDPOINTS.workflowConfig.list}/${id}`);
};
